import { useState } from 'react';
import { useClient } from 'urql';
import { graphql } from '@/gql/graphql';

const UseTeamInviteCode = graphql(/* GraphQL */ `
  query UseTeamInviteCode($teamId: uuid!) {
    invite_entry_code(args: { kind: team, entity_id: $teamId }) {
      code
    }
  }
`);

export default function useTeamInviteCode() {
  const [fetching, setFetching] = useState(false);
  const client = useClient();

  const getInviteCode = (teamId: string): PromiseLike<string | null> => {
    setFetching(true);

    return client
      .query(UseTeamInviteCode, { teamId }, { requestPolicy: 'network-only' })
      .then(
        (result) => {
          setFetching(false);
          return result.data?.invite_entry_code[0]?.code ?? null;
        },
        () => {
          setFetching(false);
          return null;
        },
      );
  };

  return { getInviteCode, fetching };
}
